<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Festivals (Contemporary Music)
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Festivals (Contemporary Music) experienced the third highest growth in revenue and the second highest growth in attendance amongst all categories in 2019, increasing by 77.3% in revenue (from $102.0m in 2018 to $180.9m in 2019) and 48.5% in attendance (from 1.0m in 2018 to 1.4m in 2019). </p>
          <p>The average ticket price increased by 12.4% (from $131.58 in 2018 to $147.86 in 2019), which further contributed to the growth in revenue. This is the highest recorded revenue, attendance and average ticket price in this category since 2004. </p>
          <p>Major events in this category in 2019 were Splendour in the Grass, Bluesfest, CMC Rocks QLD, and Festival X.</p>
          <p>Bans on mass gatherings, border closures and density limits introduced as part of COVID-19 restrictions in 2020 meant that this category experienced a significant decline in revenue (by 70.0% to $54.2m from 2019) and a decline in attendance (by 69.8% to 0.4m). A decline in the average ticket price by 3.7% (to $142.33) further contributed to the decline in revenue. Major festivals in this category in 2020 were Falls Downtown, WOMADelaide and St. Jerome's Laneway Festival.</p>
        </div>
        <div class="sixcol last">
          <p>NSW accounted for the highest market share in revenue (41.3% in 2019, 22.9% in 2020) and highest market share in attendance (38.4% in 2019, 25.5% in 2020) in this category. Major events in 2019 included Splendour in the Grass, Bluesfest, Festival X and Falls Festival. Major events in 2020 included St. Jerome's Laneway Festival, Field Day and FOMO festival.</p>
          <p>QLD accounted for the second highest market share in revenue (20.0% in 2019, 19.5% in 2020) and second highest market share in attendance (20.4% in 2019, 19.1% in 2020) in this category. The major event in 2019 was CMC Rocks QLD. The major event in 2020 was St. Jerome's Laneway Festival.</p>
          <p>In 2019, TAS experienced the highest y-o-y increase in revenue (362.4%) and the highest increase in attendance (279.9%) in Australia. SA experienced the second highest y-o-y increase in revenue (236.4%) and second highest increase in attendance (115.4%) in Australia.</p>
          <p>In 2020, all states and territories experienced a decline in revenue and attendance, due to COVID-19 restrictions prohibiting the majority of major annual music festivals from proceeding.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Nathaniel Rateliff</em>, 2019 Bluesfest, Photo Credit: Kurt Peterson</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [9.015, 12.128, 36.577, 26.972, 66.429, 55.276, 100.918, 96.453, 98.365, 107.368, 129.21, 106.825, 79.865, 100.657, 102.016, 180.853, 54.175],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.19, 0.269, 0.762, 0.753, 1.222, 0.8, 1.028, 0.985, 1.169, 1.053, 1.281, 1.3, 0.673, 0.853, 0.975, 1.448, 0.437],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 41.3],
            ["VIC", 15.3],
            ["QLD", 20.0],
            ["WA", 6.6],
            ["SA", 8.0],
            ["ACT", 4.8],
            ["TAS", 3.9],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 38.4],
            ["VIC", 16.5],
            ["QLD", 20.4],
            ["WA", 7.5],
            ["SA", 8.9],
            ["ACT", 4.4],
            ["TAS", 3.9],
            ["NT", 0.1]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 22.9],
            ["VIC", 18.0],
            ["QLD", 19.5],
            ["WA", 18.1],
            ["SA", 16.5],
            ["ACT", 0.0],
            ["TAS", 5.0],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 25.5],
            ["VIC", 17.7],
            ["QLD", 19.1],
            ["WA", 16.4],
            ["SA", 14.2],
            ["ACT", 0.0],
            ["TAS", 7.1],
            ["NT", 0.0]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/Nathaniel-Rateliff,-2019-Bluesfest,-Kurt-Peterson_SFW2.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
